import React from 'react';
import PropTypes from 'prop-types';

import './Ptext.css';

function Ptext({ children }) {
    return (
        <div className="p-text-container">
            <p>{children}</p>
        </div>
    )
}

Ptext.propTypes = {
    children: PropTypes.node
};

export default Ptext
